import { Routes, Route } from "react-router-dom";
import PrivateAuth from '../../authorization/PrivateAuth';
import AssemblyList from "../../../pages/Assembly/Main/AssemblyList";
import BomList from "../../../pages/BOM/Main/BomList";
import CreateBom from "../../../pages/BOM/Create-Bom/CreateBom";
import CreateAssembly from "../../../pages/Assembly/Create/Not_Saved/CreateAssembly";
import DraftAssembly from "../../../pages/Assembly/Create/Draft/DraftAssembly";
import AssemblyCreatepick from "../../../pages/Assembly/Create/Create-Pick/Create-pick";
import ViewAssembly from "../../../pages/Assembly/View/ViewAssembly";
import CreateStockEntry from "../../../pages/Assembly/StockEntry/CreateStockEntry";
import ViewBom from "../../../pages/BOM/View-Bom/ViewBom";
import EditBom from "../../../pages/BOM/Edit-Bom/EditBom";
import Picklist from "../../../pages/Assembly/Pick-list/Pick-list";
import Viewpick from "../../../pages/Assembly/View-Pick/Viewpick";


function AssemblyRoute() {

    return (
        <Routes>
            <Route element={<PrivateAuth />}>
                <Route path="/assembly-list" element={<AssemblyList />} />
                <Route path="/create-assembly" element={<CreateAssembly />} />
                <Route path="/view-work-order" element={<ViewAssembly />} />
                <Route path="/draft/create-assembly" element={<DraftAssembly />} />
                <Route path="/bom-list" element={<BomList />} />
                <Route path="/pick-list" element={<Picklist />} />
                <Route path="/view-pick-list" element={<Viewpick />} />
                <Route path="/create-bom" element={<CreateBom />} />
                <Route path="/create-pick" element={<AssemblyCreatepick />} />
                <Route path="/stock-entry" element={<CreateStockEntry />} />

                <Route path="/view-bom" element={<ViewBom />} />
                <Route path="/edit-bom" element={<EditBom />} />


                
               
            </Route>
        </Routes>
    );
}

export default AssemblyRoute;
